import React from "react";
import "../styles/pages/login.scss";
import LearnMore from "../components/Login/LearnMore";
import BusinessForm from "../components/Login/BusinessForm";
import { Link } from "react-router-dom";

const LoginPage = () => {
  return (
    <div>
      <div className="container-fluid sign-in">
        <div className="row d-md-flex">
          <LearnMore />
          <div className="col-xl-6 col-lg-6 col-md-6 right order-1 order-md-2 order-lg-2 order-xl-2 d-flex justify-content-center align-items-center">
            <div className="change-page-wrapper">
              Not registered yet?.
              <Link
                className="d-flex align-items-center justify-content-center btn-transparent-border-blue mt-0 btn-small"
                to="/register"
              >
                Create Account
              </Link>
            </div>
            <div className="box">
              <h2>
                <small>
                  Log in <span>Business </span> to continue
                </small>
              </h2>
              <div className="row">
                <div className="col-sm-12">
                  <div className="row">
                    <BusinessForm />
                  </div>
                </div>
                <div className="col-sm-12 pt-5 mt-5">
                  Forgot Password?
                  <Link to="/forgot-password"> Reset Password</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
